// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"367":"b536a0f1","413":"1329d575","831":"bd904a5c"}[chunkId] || chunkId) + "." + {"139":"ebb081c5fd0326ae","173":"2e3fea3a1652de02","367":"5de9d5921d55064a","413":"d21a191f4049af27","608":"669b41df089debdf","646":"120e26959f6d7237","831":"439b0908e1631365"}[chunkId] + ".js";
};